export const tasksWithoutSolving = [
    'AU01',
    'AU03',
    'IM01',
    'TX01',
    'TX02',
    'TX03',
    'VD01'
]
